import React, { useState } from 'react';
import {
  Grid,
  CircularProgress,
  Typography,
  Button,
  TextField,
  Fade,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useMutation } from '@apollo/client';
import { SIGNUP } from '../../queries/signup';
import logo from '../../assets/images/logo.png';
import useStyles from './styles';

export default function Subscribe() {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [nameValue, setNameValue] = useState('');
  const [loginValue, setLoginValue] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [confirmPasswordValue, setConfirmPasswordValue] = useState('');
  const [responseStatus, setResponseStatus] = useState(0);

  const [signUpMutation] = useMutation(SIGNUP);

  const handleSignUp = async () => {
    setError(false);
    setIsLoading(true);
    setResponseStatus(0);

    try {
      if (!loginValue && !nameValue && !confirmPasswordValue && !passwordValue) throw Error('Field empty');

      signUpMutation({ variables: { name: nameValue, email: loginValue, password: passwordValue } }).then(() => {
        setResponseStatus(1);
        setIsLoading(true);
      }, () => {
        setIsLoading(false);
        setResponseStatus(2);
      });
    } catch (e) {
      setError(true);
      setIsLoading(false);
    }
  };

  return (
    <Grid container className={classes.container}>
      <div className={classes.logotypeContainer}>
        <img src={logo} alt="logo" className={classes.logotypeImage} />
        <Typography className={classes.logotypeText}>Adireto</Typography>
        <Typography className={classes.subLogoTypeText}>Content</Typography>
      </div>
      <div className={classes.formContainer}>
        <div className={classes.form}>
          <div className={classes.titleContainer}>
            <Typography className={classes.title}>SIGN UP</Typography>
          </div>

          {
            responseStatus !== -1 && (
              <Typography variant="h3" className={classes.greeting}>
                Fill all the fields
              </Typography>
            )
          }
          {
            error && (
              <Fade in>
                <Typography color="secondary" className={classes.errorMessage}>
                  Something is wrong with your e-mail or password :(
                  {' '}
                  <br />
                  Check if your fill the e-mail field correctly!
                </Typography>
              </Fade>
            )
          }
          {responseStatus === 1
            ? (
              <Fade in>
                <Typography color="primary" className={clsx(classes.errorMessage, classes.doneMessage)}>
                  Done! Now you&apos;ll receive e-mail with new titles to work!
                  {' '}
                  <br />
                  Thanks!
                </Typography>
              </Fade>
            )
            : null}
          {responseStatus === 2
            ? (
              <Fade in>
                <Typography color="primary" className={classes.errorMessage}>
                  There is another user with the same e-mail. Please, change it and try again.
                </Typography>
              </Fade>
            )
            : null}
          {responseStatus !== 1
            ? (
              <>
                <TextField
                  id="name"
                  InputProps={{
                    classes: {
                      root: classes.firstTextField,
                      underline: classes.textFieldUnderline,
                      input: classes.textField,
                    },
                  }}
                  value={nameValue}
                  onChange={e => setNameValue(e.target.value)}
                  margin="normal"
                  placeholder="Full Name"
                  type="text"
                  fullWidth
                />
                <TextField
                  id="email"
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.textField,
                    },
                  }}
                  value={loginValue}
                  onChange={e => setLoginValue(e.target.value)}
                  margin="normal"
                  placeholder="Email Adress"
                  type="email"
                  fullWidth
                />
                <TextField
                  id="password"
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.textField,
                    },
                  }}
                  value={passwordValue}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      handleSignUp();
                    }
                  }}
                  onChange={e => setPasswordValue(e.target.value)}
                  margin="normal"
                  placeholder="Password"
                  type="password"
                  fullWidth
                />
                <TextField
                  id="confirmPassword"
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.textField,
                    },
                  }}
                  value={confirmPasswordValue}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      handleSignUp();
                    }
                  }}
                  onChange={e => setConfirmPasswordValue(e.target.value)}
                  margin="normal"
                  placeholder="Confirm Password"
                  type="password"
                  fullWidth
                />
                <div className={classes.formButtons}>
                  {isLoading ? (
                    <CircularProgress size={26} className={classes.loginLoader} />
                  ) : (
                    <Button
                      disabled={
                        nameValue.length === 0 || loginValue.length === 0 || passwordValue.length === 0 || (passwordValue !== confirmPasswordValue)
                      }
                      onClick={() => {
                        handleSignUp();
                      }}
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      Sign up
                    </Button>
                  )}
                </div>
              </>
            ) : null}
          <Link
            to={{ pathname: '/login' }}
            className={classes.loginButton}
          >
            Login
          </Link>
        </div>
        <Typography color="primary" className={classes.copyright}>
          © 2021 Adireto. All rights reserved.
        </Typography>
      </div>
    </Grid>
  );
}
